import styled from 'styled-components';

import { colors } from '../../../../utils/utils';

const Button = styled.button<{ $isCallStarted: boolean }>`
    border-radius: 24px;
    border: 0;

    padding: 12px 24px;

    font-size: 13px;
    font-weight: bold;

    background-color: ${props => (props.$isCallStarted ? colors.red.light_carmine_pink : colors.green.aquamarine)};
    color: ${colors.white.basic};

    cursor: pointer;

    outline: none;

    & > * {
        vertical-align: middle;
    }

    & > span {
        margin-left: 6px;
    }
`;

export default Button;
